import { useQuery } from 'react-query';
import OrdersApi from '../../../OrdersApi';
import { NewOrder } from '../types';

export function useNewOrderQuery(pendingOrderId: string | null) {
    return useQuery<NewOrder>(
        ['create-order-new-order', pendingOrderId],
        () => OrdersApi.newOrder(pendingOrderId || undefined),
        { cacheTime: 0, refetchOnWindowFocus: false }
    );
}
